var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetectionPropertyListDemoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 23,
    rx: 1.5,
    fill: "#F1F1F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 23,
    rx: 1.5,
    stroke: "#E4E6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6.6V17.4C18.5 17.7314 18.2314 18 17.9 18H7.1C6.76863 18 6.5 17.7314 6.5 17.4V6.6C6.5 6.26863 6.76863 6 7.1 6H17.9C18.2314 6 18.5 6.26863 18.5 6.6Z",
    stroke: "#514F55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14.666L11.1667 12.666L18.5 15.9993",
    stroke: "#514F55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 10.6667C14.4303 10.6667 13.8333 10.0697 13.8333 9.33333C13.8333 8.59695 14.4303 8 15.1667 8C15.903 8 16.5 8.59695 16.5 9.33333C16.5 10.0697 15.903 10.6667 15.1667 10.6667Z",
    stroke: "#514F55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetectionPropertyListDemoImg);
export default __webpack_public_path__ + "static/media/detectionPropertyListDemoImg.f43c272d6a1202505d5b9007bc6d1a2b.svg";
export { ForwardRef as ReactComponent };